import { render, staticRenderFns } from "./configcombo-form.vue?vue&type=template&id=8a9afeac&scoped=true"
import script from "./configcombo-form.vue?vue&type=script&lang=js"
export * from "./configcombo-form.vue?vue&type=script&lang=js"
import style0 from "./configcombo-form.vue?vue&type=style&index=0&id=8a9afeac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9afeac",
  null
  
)

export default component.exports